import GridRow from '@navi/web-ui/lib/layouts/Grid/GridRow/GridRow';
import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import styles from './willingToPayCard.module.scss';
import {
  InteractionType,
  getBrokenWtpInteractionTypeData,
  getPtpInformationTypeData
} from '../CaseDetails/feedbackForm/interfaces/index.type';
import { firstInteractionMessage } from './dc-97/dc97Constant';
import InfoIconOutlined from '../../assets/images/icons/InfoIconOutlined';
import { formatDate } from '@cp/src/utils/commonUtils';
import cx from 'classnames';
import VerticalSeperator from '@cp/src/components/VerticalSeperator';
import { IPtpInfoType } from '@cp/src/reducers/commonSlice';

interface WillingToPayCardProps {
  isFirstInteraction: boolean;
  previousCallDate: string;
  willingToPayDate: string;
  willingToPayText: string;
  interactionType: InteractionType;
  ptpInfoIfAny: IPtpInfoType;
}

const WillingToPayCard = (props: WillingToPayCardProps) => {
  const {
    isFirstInteraction,
    previousCallDate,
    willingToPayDate,
    willingToPayText,
    interactionType,
    ptpInfoIfAny
  } = props;

  const { date, text, type, brokenPtpCount } = ptpInfoIfAny || {};
  const showPtpInfo = !(typeof ptpInfoIfAny === 'object' && Object.keys(ptpInfoIfAny).length === 0);

  const { label, Icon, bgColor } = getBrokenWtpInteractionTypeData(interactionType) || {};

  const { ptpLabel, ptpBgColor, textColor, borderColor } = getPtpInformationTypeData(type) || {};

  return (
    <div className={cx(styles.willingToPayContainer, { 'justify-start': isFirstInteraction })}>
      {isFirstInteraction ? (
        <>
          <div className={styles.firstInteractionContainer}>
            <Typography variant="p3" className={styles.subHeadingStyle}>
              Last Interaction
            </Typography>
            <div className={styles.interactionMessage}>
              <InfoIconOutlined />
              {firstInteractionMessage}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className={styles.topContainer}>
            <div className={styles.willingPreviousCard}>
              <Typography variant="p3" className={styles.subHeadingStyle}>
                Last Interaction
                <span className={styles.brokenWtpIcon}>
                  {Icon && <Icon className={styles.brokenWtpIcon} />}
                </span>
              </Typography>
              <Typography variant="p3" className={styles.previousDate}>
                {previousCallDate}
              </Typography>
            </div>
            <div className={styles.previousFeedbackContainer}>
              <Typography variant="p3" className={styles.subHeadingStyle}>
                Previous Feedback
              </Typography>
              <GridRow className={styles.previousFeedback}>
                <Typography variant="p3" className={styles.previousFeedbackText}>
                  {willingToPayText || '--'}
                </Typography>
              </GridRow>
            </div>
          </div>
          <div className={cx(styles.bottomContainer, { 'py-[13px]': !showPtpInfo })}>
            <Typography variant="h4" className={styles.subHeadingStyle} color="var(--grayscale-1)">
              PTPs:
            </Typography>
            {showPtpInfo ? (
              <>
                <div>
                  <div
                    className={cx(
                      'flex row items-baseline gap-1 px-2 py-[2px] rounded-md border border-solid'
                    )}
                    style={{ backgroundColor: ptpBgColor, borderColor: borderColor }}
                  >
                    <Typography variant="p3" color={textColor}>
                      {ptpLabel}
                    </Typography>
                    <Typography variant="p3" className={'text-[10px]'} color={textColor}>
                      {formatDate(date, { year: undefined })}
                    </Typography>
                  </div>
                </div>
                <VerticalSeperator color="#c6c6c6" height="16px" />
                {brokenPtpCount > 0 ? (
                  <>
                    <Typography variant="p3" color="var(--red-base)">
                      {brokenPtpCount}
                    </Typography>
                    <Typography variant="p3" color="var(--grayscale-2)">
                      broken in past
                    </Typography>
                  </>
                ) : (
                  <Typography variant="p3" className={styles.ptpDate}>
                    No broken in past
                  </Typography>
                )}
              </>
            ) : (
              <Typography variant="p3" color="var(--grayscale-2)">
                No past PTPs
              </Typography>
            )}
          </div>
        </>
      )}
    </div>
  );
};
export default WillingToPayCard;
